import { Suspense } from "react";
import "./App.css";
import RootRoute from "./routes";
import { theme } from "./theme/Theme";
import { ThemeProvider } from "@mui/material";
import { Constants } from "./utils/constants/Constants";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Suspense fallback={Constants.TEXT_LOADING}>
        <RootRoute />
      </Suspense>
      <Toaster />
    </ThemeProvider>
  );
}

export default App;
